import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { Dispatch, SetStateAction, useEffect } from 'react'
import { useStyles } from './styles'

type Order = 'ASC' | 'DESC'

interface ITableHeader {
  headCells: ITableHeadDTO[]
  order: Order[]
  setOrder: Dispatch<SetStateAction<Order[]>>
  handleSortChange: (value: number) => void
}

const TableHeader: React.FC<ITableHeader> = ({ headCells, order, setOrder, handleSortChange }) => {
  const classes = useStyles()

  const defaultWidth = headCells.length > 1 ? 90 / headCells.length : 80

  useEffect(() => {
    const sortArray: Array<'ASC' | 'DESC'> = headCells.map(() => 'ASC')

    setOrder(sortArray)
  }, [headCells])

  return (
    <TableHead className={classes.root}>
      <TableRow
        key={Math.random()}
        sx={{ position: 'relative' }}
      >
        {headCells.map((headCell, index) => (
          <TableCell
            key={Math.random()}
            align='left'
            className={classes.tableCell}
            style={{
              width: `${typeof headCell.width !== 'undefined' ? (headCell.width * 90) / 12 : defaultWidth}%`,
            }}
          >
            <TableSortLabel
              active={true}
              className={classes.tableSortCell}
              onClick={() => handleSortChange(index)}
              direction={order[index] === 'ASC' ? 'desc' : 'asc'}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell className={classes.rowTableIcon}>&nbsp;</TableCell>
      </TableRow>
    </TableHead>
  )
}

export default TableHeader
